import { NgModule } from '@angular/core';
import { MarketProfileRoutingModule } from './market-profile-routing.module';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { MarketProfileOverviewComponent } from './marketprofile-overview/market-profile-overview.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatChipsModule } from '@angular/material/chips';
import { MatListModule } from '@angular/material/list';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SharedModule } from '../shared/shared.module';
import {
  RemoveMarketProfileDialogComponent,
} from './remove-market-profile-dialog/remove-market-profile-dialog.component';
import { UpdateMarketProfileFormComponent } from './update-market-profile-form/update-market-profile-form.component';
import { MarketProfileDetailsComponent } from './market-profile-details/market-profile-details.component';
import { CreateMarketProfileFormComponent } from './create-market-profile-form/create-market-profile-form.component';

@NgModule({
  declarations: [
    MarketProfileOverviewComponent,
    RemoveMarketProfileDialogComponent,
    UpdateMarketProfileFormComponent,
    MarketProfileDetailsComponent,
    CreateMarketProfileFormComponent
  ],
  imports: [
    MarketProfileRoutingModule,
    MatTableModule,
    MatPaginatorModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatListModule,
    MatDialogModule,
    MatDividerModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
  ]
})
export class MarketProfileModule { }
